import React from "react";
import { ReactComponent as Image404 } from "../images/404.svg";
import { HomeIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

import {
  UilWallet,
  UilCreateDashboard,
  UilShoppingCart,
} from "@iconscout/react-unicons";

export const Page404 = () => {
  return (
    <div>
      <div className="bg-pagePattern bg-center">
        <div className="flex mx-auto max-w-screen-lg text-center justify-center items-center mb-9 h-32  ">
          <span className="text-7xl text-textWhite font-medium  ">
            Page Not Found
          </span>
        </div>
      </div>

      <div className="ml-4"></div>

      <div className="flex flex-col mx-auto max-w-screen-lg text-center justify-center items-center">
        {/* Give link to dashboard */}
        <div className="flex flex-row gap-10">
          {/* Secondary Link - Home with Icon */}
          <Link
            to="/"
            state={{ PageTitle: "Home" }}
            className="flex items-center text-primary hover:underline"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-textWhite hover:bg-primaryHover focus:ring-2 focus:ring-secondary">
              <HomeIcon className="w-5 h-5" />
            </div>
            <span className="ml-2 text-sm font-semibold">Go to Home</span>
          </Link>

          {/* Secondary Link - Dashboard with Icon */}
          <Link
            to="/user/dashboard"
            state={{ PageTitle: "Dashboard" }}
            className="flex items-center text-primary hover:underline"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-textWhite hover:bg-primaryHover focus:ring-2 focus:ring-secondary">
              <UilCreateDashboard className="w-5 h-5" />
            </div>
            <span className="ml-2 text-sm font-semibold">Go to Dashboard</span>
          </Link>

          {/* Secondary Link - Wallet with Icon */}
          <Link
            to="/user/zulalwallet"
            state={{ PageTitle: "Zulal Wallet" }}
            className="flex items-center text-primary hover:underline"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-textWhite hover:bg-primaryHover focus:ring-2 focus:ring-secondary">
              <UilWallet className="w-5 h-5" />
            </div>
            <span className="ml-2 text-sm font-semibold">Go to Wallet</span>
          </Link>

          {/* Secondary Link - Shopping with Icon */}
          <Link
            to="/productsrange"
            state={{ PageTitle: "Zulal Store" }}
            className="flex items-center text-primary hover:underline"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-textWhite hover:bg-primaryHover focus:ring-2 focus:ring-secondary">
              <UilShoppingCart className="w-5 h-5" />
            </div>
            <span className="ml-2 text-sm font-semibold">Go Shopping</span>
          </Link>
        </div>

        <div>
          <Image404 />
        </div>
        <div className="text-red-500 text-xl font-normal">
          ERROR 404 - PAGE NOT FOUND
        </div>
        <div className="text-zinc-500 text-base mb-20 font-normal uppercase tracking-widest">
          the page you requested could not be Found
        </div>
      </div>
    </div>
  );
};
